
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/investors",
      function () {
        return require("private-next-pages/africa/investors.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/investors"])
      });
    }
  